//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Vue from 'vue'
import VueVideoPlayer from 'vue-video-player'
 
// require videojs style
import 'video.js/dist/video-js.css'
// import 'vue-video-player/src/custom-theme.css'
 
Vue.use(VueVideoPlayer, /* {
  options: global default options,
  events: global videojs events
} */)
  
  export default {
    data() {
      return {
        // videojs options
        zdyplay:true,
      }
    },
    props: {
      imgFlag:{
        type:Boolean,
        default:true,
      },
      playerOptions:{
        type: Object,
        default(){
          return {
              height: document.body.clientWidth,
              width: document.body.clientWidth,
              autoplay: false,
              muted: true,
              language: 'en',
              // controlBar: {fullscreenToggle: false},
              playbackRates: [0.7, 1.0, 1.5, 2.0],
              sources: [{
                type: "video/mp4",
                // mp4
                src: "https://videosy.soyoung.com/sy-pre/2019115/aTtt5Xjpu.mp4",
                // webm
                // src: "https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm"
              }],
              poster: "https://static.soyoung.com/sy-pre/bg-1573636206635.png",
            }
        }
      }
    },
    created(){
    },
    mounted() {
        // this.playerOptions.height = document.body.clientWidth
        // this.playerOptions.width = document.body.clientWidth
        // //console.log('document.body.clientWidth',document.body.clientWidth)
      // //console.log('this is current player instance object', this.player)
      setTimeout(() => {
        //console.log('dynamic change options', this.player)
        // change src
        // this.playerOptions.sources[0].src = 'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm';
        // change item
        // this.$set(this.playerOptions.sources, 0, {
        //   type: "video/mp4",
        //   src: 'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm',
        // })
        // change array
        // this.playerOptions.sources = [{
        //   type: "video/mp4",
        //   src: 'https://cdn.theguardian.tv/webM/2015/07/20/150716YesMen_synd_768k_vp8.webm',
        // }]
        this.player.muted(false)
      }, 5000)
    },
    computed: {
      player() {
        return this.$refs.videoPlayer.player
      }
    },
    methods: {
      // listen event
      onPlayerPlay(player) {
        //console.log('player play!', player)
        this.$emit("onPlayerPlay", player)
      },
      onPlayerPause(player) {
        // //console.log('player pause!', player)
      },
      onPlayerEnded(player) {
        // //console.log('player ended!', player)
      },
      onPlayerLoadeddata(player) {
        // //console.log('player Loadeddata!', player)
      },
      onPlayerWaiting(player) {
        // //console.log('player Waiting!', player)
      },
      onPlayerPlaying(player) {
        // //console.log('player Playing!', player)
      },
      onPlayerTimeupdate(player) {
        // //console.log('player Timeupdate!', player.currentTime())
      },
      onPlayerCanplay(player) {
        // //console.log('player Canplay!', player)
      },
      onPlayerCanplaythrough(player) {
        // //console.log('player Canplaythrough!', player)
      },
      // or listen state event
      playerStateChanged(playerCurrentState) {
        // //console.log('player current update state', playerCurrentState)
      },
      // player is ready
      playerReadied(player) {
        // seek to 10s
        // //console.log('example player 1 readied', player)
        // player.currentTime(10)
        // //console.log('example 01: the player is readied', player)
      },
      play(){ 
          this.player.play(); 
          this.zdyplay = false;
      },
    }
  }
